import React from 'react';

import { connect } from 'react-redux';
import { Collapse, Navbar, NavbarToggler, NavbarBrand, Nav, Container } from 'reactstrap';

//Componentes auxiliares:
import LogoutButton from '../components/LogoutButton';
import DownloadManualButton from "../components/DownloadManualButton";
import FeedbackButton from "../components/FeedbackButton";

//Scrips auxiliares:
import mainMenuRoutes from "../menuRoutes/mainMenuRoutes";

class Header extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            isOpen: false,
            dropdownOpen: false,
            color: "transparent"
        };

        this.toggle = this.toggle.bind(this);
        this.dropdownToggle = this.dropdownToggle.bind(this);
        this.sidebarToggle = React.createRef();
    }

    toggle() {
        if (this.state.isOpen) {
            this.setState({
                color: "transparent"
            });
        } else {
            this.setState({
                color: "dark"
            });
        }
        this.setState({
            isOpen: !this.state.isOpen
        });
    }

    dropdownToggle(e) {
        this.setState({
            dropdownOpen: !this.state.dropdownOpen
        });
    }

    getBrand() {
        let brandName = "Fit Ideas SAS®";
        
        // Check regular routes and nested routes from dropdowns
        mainMenuRoutes.map((prop, key) => {
            // Check if it's a regular route (not dropdown)
            if (prop.path && window.location.href.indexOf(prop.layout + prop.path) !== -1) {
                brandName = prop.subname;
            }
            // Check if it's a dropdown with children
            else if (prop.dropdown && prop.children) {
                prop.children.map((child, childKey) => {
                    if (window.location.href.indexOf(child.layout + child.path) !== -1) {
                        brandName = child.subname;
                    }
                    return null;
                });
            }
            return null;
        });
        return brandName;
    }

    openSidebar() {
        document.documentElement.classList.toggle("nav-open");
        this.sidebarToggle.current.classList.toggle("toggled");
    }

    // function that adds color dark/transparent to the navbar on resize (this is for the collapse)
    updateColor() {
        if (window.innerWidth < 993 && this.state.isOpen) {
            this.setState({
                color: "dark"
            });
        } else {
            this.setState({
                color: "transparent"
            });
        }
    }

    componentDidMount() {
        window.addEventListener("resize", this.updateColor.bind(this));
    }

    componentDidUpdate(e) {
        if (window.innerWidth < 993 && e.history.location.pathname !== e.location.pathname && document.documentElement.className.indexOf("nav-open") !== -1) {
            document.documentElement.classList.toggle("nav-open");
            this.sidebarToggle.current.classList.toggle("toggled");
        }
    }

    render() {

        return (
            // add or remove classes depending if we are on full-screen-maps page or not
            <Navbar color={window.location.pathname.indexOf("full-screen-maps") !== -1 ? "dark" : this.state.color} expand="lg"
                className={window.location.pathname.indexOf("full-screen-maps") !== -1 ? "navbar-absolute fixed-top" : "navbar-absolute fixed-top " +
                    (this.state.color === "transparent" ? "navbar-transparent " : "")}>

                <Container fluid>
                    <div className="navbar-wrapper">
                        <div className="navbar-toggle">
                            <button
                                type="button"
                                ref={this.sidebarToggle}
                                className="navbar-toggler"
                                onClick={() => this.openSidebar()}>
                                <span className="navbar-toggler-bar bar1" />
                                <span className="navbar-toggler-bar bar2" />
                                <span className="navbar-toggler-bar bar3" />
                            </button>
                        </div>
                        <NavbarBrand >
                            <p style={{ textTransform: "none" }} className="noselect">
                                {this.getBrand()}
                            </p>
                        </NavbarBrand>
                    </div>

                    <NavbarToggler onClick={this.toggle}>
                        <span className="navbar-toggler-bar navbar-kebab" />
                        <span className="navbar-toggler-bar navbar-kebab" />
                        <span className="navbar-toggler-bar navbar-kebab" />
                    </NavbarToggler>

                    <Collapse isOpen={this.state.isOpen} navbar className="justify-content-end">
                        <p style={{ marginRight: 10 }} className="text-on-navbar">
                            {this.props.activeUser.email.split("@")[0]}
                            <b>{"@" + this.props.activeUser.email.split("@")[1]}</b>
                        </p>

                        <Nav navbar>
                            {/* Acá comienzan los botones de funcionalidades del navbar */}
                            {this.getRenderedNavbarButtons()}
                            <FeedbackButton userEmail={this.props.activeUser.email} />
                            <LogoutButton />
                        </Nav>
                    </Collapse>
                </Container>
            </Navbar>
        );
    }

    getRenderedNavbarButtons = () => {
        let navbarButtons = [];

        for (let i = 0; i < this.props.navbarButtons.length; i++) {
            navbarButtons.push(
                <React.Fragment key={"navbarButton." + i}>
                    {this.props.navbarButtons[i]}
                </React.Fragment>
            );
        }

        return navbarButtons;
    }
}

//Para conexión con storage redux: 

const mapStateToProps = state => {
    return {
        activeUser: state.mainReducer.activeUser,
        navbarButtons: state.navbarReducer.navbarButtons
    };
};

export default connect(mapStateToProps)(Header);